// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../style.css\"","easilBlack":"#2c2e2f","h3":"style_h3__1izxj"};